
import { common as enCommon } from './en/common';
import { common as zhTWCommon } from './zh-TW/common';

const messages = {
  en: {
    common: enCommon,
  },
  'zh-TW': {
    common: zhTWCommon,
  },
};

export default messages;
